export default __webpack_public_path__ + "static/media/amex.a1d716b0.png";